// components/common/InfoModal/InfoModal.js
import React from 'react';
import { Modal, Button } from 'antd';
import {
  InfoCircleOutlined,
  QuestionCircleOutlined,
  BulbOutlined,
} from '@ant-design/icons';
import './index.css';

const InfoModal = ({
  visible,
  onClose,
  title,
  icon = 'info',
  width = 600,
  children,
  buttonText = 'Got it!',
  className = '',
}) => {
  const getIcon = () => {
    switch (icon) {
      case 'question':
        return <QuestionCircleOutlined />;
      case 'bulb':
        return <BulbOutlined />;
      case 'info':
      default:
        return <InfoCircleOutlined />;
    }
  };

  return (
    <Modal
      title={
        <div className='info-modal-title'>
          <span className='info-modal-icon'>{getIcon()}</span>
          <span className='info-modal-title-text'>{title}</span>
        </div>
      }
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key='close' type='primary' onClick={onClose}>
          {buttonText}
        </Button>,
      ]}
      width={width}
      centered
      className={`info-modal ${className}`}
    >
      <div className='info-modal-content'>{children}</div>
    </Modal>
  );
};

export default InfoModal;
